import { render, staticRenderFns } from "./BalanceVanCollapseContent.vue?vue&type=template&id=6579f80e&scoped=true"
import script from "./BalanceVanCollapseContent.vue?vue&type=script&lang=js"
export * from "./BalanceVanCollapseContent.vue?vue&type=script&lang=js"
import style0 from "./BalanceVanCollapseContent.vue?vue&type=style&index=0&id=6579f80e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6579f80e",
  null
  
)

export default component.exports